// extracted by mini-css-extract-plugin
export default {"buttonReset":"SwipeAction_buttonReset__306eo","base":"SwipeAction_base__1UykJ","icon":"SwipeAction_icon__0Rjcq"};